// import React, { useEffect, useRef, useState } from "react";
// import { Applogo, profileLogo } from "../../../Routes/ImagePath";
// import { DatePicker } from "antd";
// import { useNavigate } from "react-router-dom";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import { ErrorToast, SuccessToast } from "../../ToastComponent";

// export const ChannelPartnerModal = ({ChannelPartnerVisitDataFetch}) => {

//   const fileInputRef = useRef(null);

//   const [tableData, setTableData] = useState([]);
//   const [allBranch, setAllBranch] = useState([]);
//   const [localFormData, setLocalFormData] = useState({
//     BranchId: Number,
//     Name: "",
//     Mobile: "",
//     IsIMDCollected: false,
//     ExpectedDate: "",
//     Selfie: null,
//     Latitude: "",
//     Longitude: "",
//   });

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setLocalFormData({ ...localFormData, Selfie: file });
//   };

//   const handleDateChange = (date) => {
//     setLocalFormData({ ...localFormData, ExpectedDate: date });
//   };

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {
//         const { latitude, longitude } = position.coords;
//         setLocalFormData({ ...localFormData, Latitude: latitude, Longitude: longitude });
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formatDateToUTC = (dateString) => {
//       const date = new Date(dateString);
//       const year = date.getUTCFullYear();
//       const month = String(date.getUTCMonth() + 1).padStart(2, '0');
//       const day = String(date.getUTCDate()).padStart(2, '0');
//       const hours = String(date.getUTCHours()).padStart(2, '0');
//       const minutes = String(date.getUTCMinutes()).padStart(2, '0');
//       const seconds = String(date.getUTCSeconds()).padStart(2, '0');
//       const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');
//       return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
//     };

//     if (localFormData.Mobile.length !== 10) {
//       ErrorToast("Mobile Number must be exactly 10 digits.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("BranchId", localFormData.BranchId);
//     formData.append("Name", localFormData.Name);
//     formData.append("Mobile", localFormData.Mobile);
//     formData.append("ExpectedDate", !localFormData.IsPurposeMet ? formatDateToUTC(localFormData.ExpectedDate) : "");
//     formData.append("IsPurposeMet", localFormData.IsPurposeMet);
//     formData.append("Latitude", localFormData.Latitude);
//     formData.append("Longitude", localFormData.Longitude);

//      const formattedData = {
//         ...localFormData,
//         ExpectedDate: localFormData.ExpectedDate
//           ? formatDateToUTC(localFormData.ExpectedDate)
//           : "",
//       };

//       console.log(formattedData);

//     try {
//       const response = await axios.post(`${Api_Url}api/v1/ChannelPartner`, formattedData, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       console.log(response);
//       ChannelPartnerVisitDataFetch()
//       resetForm()
//       SuccessToast("Channel Partner Submitted Successfully")
//     } catch (error) {
//       console.log("Error submitting form", error);
//     }
//   };

//   const resetForm = () => {
//     setLocalFormData({
//       BranchId: Number,
//       Name: "",
//       Mobile: "",
//       IsIMDCollected: false,
//       ExpectedDate: "",
//       Selfie: null,
//     });
//     setIsCollected(false);
//     setIsNotCollected(false);
//     setIsPartialCollected(false);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

//   const handleCheckboxChange = (module, column) => {
//     const updatedTableData = [...tableData];
//     const row = updatedTableData.find((item) => item.module === module);
//     row[column] = !row[column];
//     setTableData(updatedTableData);
//   };

//   const fetchAllBranches = async () => {
//     try {
//       const response = await axios.get(`${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       });
//       setAllBranch(response.data.data);
//     } catch (error) {
//       console.log("Error fetching branches", error);
//     }
//   };

//   useEffect(() => {
//     fetchAllBranches();
//   }, []);

//   const validateMobileNumber = (number) => {
//     const regex = /^[0-9]{0,10}$/;
//     return regex.test(number);
//   };

//   const handleMobileChange = (e) => {
//     const value = e.target.value;
//     if (validateMobileNumber(value)) {
//       setLocalFormData({
//         ...localFormData,
//         Mobile: value,
//       });
//     }}

//   return (
//     <>
//       <div id="add_client" className="modal custom-modal fade" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
//         <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Channel Partner Visit</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   src={Applogo || profileLogo}
//                   alt='profile'
//                   className="img-fluid rounded-circle"
//                   style={{ width: '100px', height: '100px' }}
//                 />
//               </div>
//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={localFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...localFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allBranch && allBranch.length > 0 && allBranch.map((res) => (
//                           <option key={res.id} value={res.id}>{res.name}</option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Customer Name <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={localFormData.Name} onChange={(e) => setLocalFormData({ ...localFormData, Name: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={localFormData.Mobile} onChange={handleMobileChange} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="col-form-label">Upload Document <span className="text-danger">*</span></label>
//                     <input
//                       className="form-control"
//                       type="file"
//                       accept="image/*"
//                       ref={fileInputRef}
//                       // value={LocalFormData.Selfie}
//                       onChange={handleFileChange}
//                     />
//                   </div>
//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       Purpose Met <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="purposeMet"
//                         value="true"
//                         checked={localFormData.IsPurposeMet === true}
//                         onChange={() => setLocalFormData({ ...localFormData, IsPurposeMet: true })}
//                       />
//                       <label className="form-check-label">Yes</label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="purposeMet"
//                         value="false"
//                         checked={localFormData.IsPurposeMet === false}
//                         onChange={() => setLocalFormData({ ...localFormData, IsPurposeMet: false })}
//                       />
//                       <label className="form-check-label">No</label>
//                     </div>
//                   </div>
//                   {localFormData.IsPurposeMet === false && (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Expected Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           value={localFormData.ExpectedDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={handleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div id="edit_client" className="modal custom-modal fade" role="dialog">
//         <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Edit Client</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//             <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={localFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...localFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allBranch && allBranch.length > 0 && allBranch.map((res) => (
//                           <option key={res.id} value={res.id}>{res.name}</option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Customer Name <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={localFormData.Name} onChange={(e) => setLocalFormData({ ...localFormData, Name: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={localFormData.Mobile} onChange={(e) => setLocalFormData({ ...localFormData, Mobile: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="col-form-label">Upload Document <span className="text-danger">*</span></label>
//                     <input
//                       className="form-control"
//                       type="file"
//                       // value={LocalFormData.Selfie}
//                       onChange={handleFileChange}
//                     />
//                   </div>
//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       Purpose Met <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="purposeMet"
//                         value="true"
//                         checked={localFormData.IsPurposeMet === true}
//                         onChange={() => setLocalFormData({ ...localFormData, IsPurposeMet: true })}
//                       />
//                       <label className="form-check-label">Yes</label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="purposeMet"
//                         value="false"
//                         checked={localFormData.IsPurposeMet === false}
//                         onChange={() => setLocalFormData({ ...localFormData, IsPurposeMet: false })}
//                       />
//                       <label className="form-check-label">No</label>
//                     </div>
//                   </div>
//                   {localFormData.IsPurposeMet === false && (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Expected Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           value={localFormData.ExpectedDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={handleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// Modal

import React, { useEffect, useRef, useState } from "react";
import { DatePicker, Modal } from "antd";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../ToastComponent";
import { AllFormsUpperphoto } from "../../../Routes/ImagePath";

export const ChannelPartnerModal = ({
  ChannelPartnerVisitDataFetch,
  onClose,
}) => {
  const fileInputRef = useRef(null);

  const [allBranch, setAllBranch] = useState([]);
  const [loading, setLoading] = useState(false);
  const [localFormData, setLocalFormData] = useState({
    BranchId: "",
    Name: "",
    Mobile: "",
    IsPurposeMet: null, // Ensure this starts as null for validation
    ExpectedDate: null,
    Selfie: null,
    Latitude: "",
    Longitude: "",
  });

  // Handle file upload
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLocalFormData({ ...localFormData, Selfie: file });
    }
  };

  const handleDateChange = (date) => {
    setLocalFormData({ ...localFormData, ExpectedDate: date });
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setLocalFormData({
          ...localFormData,
          Latitude: latitude,
          Longitude: longitude,
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Format date to UTC
    const formatDateToUTC = (dateString) => {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      const hours = String(date.getUTCHours()).padStart(2, "0");
      const minutes = String(date.getUTCMinutes()).padStart(2, "0");
      const seconds = String(date.getUTCSeconds()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    };

    // Mobile number validation
    if (localFormData.Mobile.length !== 10) {
      ErrorToast("Mobile Number must be exactly 10 digits.");
      setLoading(false);
      return;
    }

    // Validate file upload
    if (!localFormData.Selfie) {
      ErrorToast("Please upload a selfie.");
      setLoading(false);
      return;
    }

    // Validate purpose selection
    if (localFormData.IsPurposeMet === null) {
      ErrorToast("Please select if the purpose is met.");
      setLoading(false);
      return;
    }

    // If purpose is not met, validate expected date
    if (localFormData.IsPurposeMet === false && !localFormData.ExpectedDate) {
      ErrorToast("Please provide an expected date.");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("BranchId", localFormData.BranchId);
    formData.append("Name", localFormData.Name);
    formData.append("Mobile", localFormData.Mobile);
    formData.append(
      "ExpectedDate",
      !localFormData.IsPurposeMet
        ? formatDateToUTC(localFormData.ExpectedDate)
        : ""
    );
    formData.append("IsPurposeMet", localFormData.IsPurposeMet);
    formData.append("Latitude", localFormData.Latitude);
    formData.append("Longitude", localFormData.Longitude);
    formData.append("Selfie", localFormData.Selfie); // Append file to formData

    try {
      const response = await axios.post(
        `${Api_Url}api/v1/ChannelPartner`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(response);
      ChannelPartnerVisitDataFetch();
      resetForm();
      SuccessToast("Channel Partner Submitted Successfully");
      onClose();
    } catch (error) {
      ErrorToast("An error occurred while submitting.");
      console.log("Error submitting form", error);
    }
    setLoading(false);
  };

  const resetForm = () => {
    setLocalFormData({
      BranchId: "",
      Name: "",
      Mobile: "",
      IsPurposeMet: null,
      ExpectedDate: null,
      Selfie: null,
      Latitude: "",
      Longitude: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const fetchAllBranches = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setAllBranch(response.data.data);
    } catch (error) {
      console.log("Error fetching branches", error);
    }
  };

  useEffect(() => {
    fetchAllBranches();
  }, []);

  const validateMobileNumber = (number) => {
    const regex = /^[0-9]{0,10}$/;
    return regex.test(number);
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (validateMobileNumber(value)) {
      setLocalFormData({
        ...localFormData,
        Mobile: value,
      });
    }
  };

  return (
    <>
      <Modal
        title={<h4>Channel Partner Visit</h4>}
        open={true}
        onOk={onClose}
        onCancel={onClose}
        footer={[
          <div
            className="d-flex justify-content-between align-items-center"
            key="footer"
          >
            <button className="btn btn-danger submit-btn" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-primary submit-btn"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>,
        ]}
        width={600}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body mt-5">
          <div className="profile-image text-center mt-4 mb-4">
            <img
              src={AllFormsUpperphoto}
              alt="Profile"
              className="img-fluid rounded-circle"
              style={{ width: "100px", height: "100px" }}
            />
          </div>
          <form>
            <div className="row">
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Branch <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={localFormData.BranchId}
                    onChange={(e) =>
                      setLocalFormData({
                        ...localFormData,
                        BranchId: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Branch</option>
                    {allBranch &&
                      allBranch.length > 0 &&
                      allBranch.map((res) => (
                        <option key={res.id} value={res.id}>
                          {res.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Customer Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={localFormData.Name}
                    onChange={(e) =>
                      setLocalFormData({
                        ...localFormData,
                        Name: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Mobile <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    value={localFormData.Mobile}
                    onChange={handleMobileChange}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label className="col-form-label">
                  Upload Document <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                />
              </div>
              <div className="col-md-12">
                <label className="col-form-label">
                  Purpose Met <span className="text-danger">*</span>
                </label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="purposeYes"
                    name="purposeMet"
                    checked={localFormData.IsPurposeMet === true}
                    onChange={() =>
                      setLocalFormData({ ...localFormData, IsPurposeMet: true })
                    }
                  />
                  <label className="form-check-label" htmlFor="purposeYes">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="purposeNo"
                    name="purposeMet"
                    checked={localFormData.IsPurposeMet === false}
                    onChange={() =>
                      setLocalFormData({
                        ...localFormData,
                        IsPurposeMet: false,
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="purposeNo">
                    No
                  </label>
                </div>
              </div>
              {localFormData.IsPurposeMet === false && (
                <div className="col-md-12 mt-3">
                  <label className="col-form-label">
                    Expected Date <span className="text-danger">*</span>
                  </label>
                  <DatePicker
                    className="form-control"
                    value={localFormData.ExpectedDate}
                    onChange={handleDateChange}
                  />
                </div>
              )}
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

// export default ChannelPartnerModal;

{
  /* <div className="col-md-12">
<label className="col-form-label">
    File Logged In <span className="text-danger">*</span>
</label>
<div className="form-check">
    <input
        className="form-check-input"
        type="radio"
        name="flexRadioDefault"
        id="flexRadioDefault1"
        value="true"
        checked={radioValue === true}
        onChange={handleRadioChange}
    />
    <label className="form-check-label" htmlFor="flexRadioDefault1">
        Yes
    </label>
</div>
<div className="form-check">
    <input
        className="form-check-input"
        type="radio"
        name="flexRadioDefault"
        id="flexRadioDefault2"
        value="false"
        checked={radioValue === false}
        onChange={handleRadioChange}
    />
    <label className="form-check-label" htmlFor="flexRadioDefault2">
        No
    </label>
</div>
</div> */
}

{
  /* Conditional rendering based on radio selection */
}
// {radioValue === true ? (
// <div className="col-md-6">
//     <div className="input-block mb-3">
//         <label className="col-form-label">
//             Application Number <span className="text-danger">*</span>
//         </label>
//         <input
//             className="form-control"
//             type="text"
//             value={localFormData.ApplicationNo}
//             onChange={(e) => setLocalFormData({ ...localFormData, ApplicationNo: e.target.value })}
//         />
//     </div>
// </div>
// ) : (
// <div className="col-md-6">
//     <div className="input-block mb-3">
//         <label className="col-form-label">
//             Visit Date <span className="text-danger">*</span>
//         </label>
//         <DatePicker
//             selected={localFormData.VisitDate}
//             onChange={handleDateChange}
//             className="form-control"
//             minDate={new Date()}
//         />
//     </div>
// </div>
// )}
